import React, { useState } from 'react';
import { ReactMultiEmail } from 'react-multi-email';
import './style.css';
import { Button, InputField, Label, Loader, Modal, Tab } from '../../../../Components/uielements';

import {
  OutlineButton,
  ModalButtonWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalLabel, ModalWrapperInviteVisitor, TabWrapper } from '../user.style';
import {
  inviteDistributorByAdmin,
  inviteVisitor,
  inviteVisitorViaPhone,
} from '../../../../services/bioplus-services/user';
import { IntlMessages } from '../../../../helper/langHelper';
import InviteVisitorModalViaPhone from './inviteVisitorViaPhone';
import { useUserContext } from '../../../../hooks/UserContext';
// import { useCompany } from '../../../../hooks/CompanyContext';

const InviteVisitorModal = ({ onClose, companyId }) => {
  const [emails, setEmails] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState(undefined);
  const [activeTab, setActiveTab] = useState('email');
  const [distributorEmail, setDistributorEmail] = useState();

  const userContext = useUserContext();
  const role = userContext?.company?.role;
  const distributorRoleId = userContext?.company?._id;

  // const companyContext = useCompany();

  const handleSendInvitation = async () => {
    try {
      const payload = { emails: emails };
      setIsProcessing(true);
      if (role !== 'ADMIN') {
        await inviteVisitor(companyId, payload, role === 'PARTNER' && distributorRoleId);
      } else {
        await inviteDistributorByAdmin(companyId, { email: distributorEmail });
      }
      setIsProcessing(false);
      alert('Invitation sent successfully to the Member.');
      onClose();
    } catch (e) {
      setIsProcessing(false);
      setError(e?.response?.data?.message);
    }
  };

  const handleSendInvitationViaPhone = async (phoneNumbers) => {
    try {
      const payload = { phoneNumbers: phoneNumbers };
      setIsProcessing(true);
      await inviteVisitorViaPhone(companyId, payload);
      setIsProcessing(false);
      alert('Invitation sent successfully to the Member.');
      onClose();
    } catch (e) {
      setIsProcessing(false);
      setError(e?.response?.data?.message);
    }
  };

  const tabArray = [
    {
      buttonText: 'Email',
      value: 'email',
      textId: '1',
    },
    {
      buttonText: 'Phone',
      value: 'phone',
      textId: '2',
    },
  ];

  const handleTabClick = (clickedTab) => {
    if (clickedTab) {
      setActiveTab(clickedTab);
    }
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'email':
        return !error ? (
          <ModalWrapperInviteVisitor>
            {role !== 'ADMIN' && <Label>Email</Label>}
            {role !== 'ADMIN' ? (
              <ReactMultiEmail
                placeholder="Input your email..."
                emails={emails}
                onChange={(_emails) => {
                  setEmails(_emails);
                }}
                getLabel={(email, index, removeEmail) => {
                  return (
                    <div data-tag key={index}>
                      <div data-tag-item>
                        {email}
                        <span data-tag-handle onClick={() => removeEmail(index)}>
                          ×
                        </span>
                      </div>
                    </div>
                  );
                }}
              />
            ) : (
              <InputField
                value={distributorEmail}
                onChange={(e) => setDistributorEmail(e.target.value)}
                fullWidth
                Name="Input your email..."
              />
            )}
            <ModalButtonWrapper style={{ marginTop: '20px' }}>
              <OutlineButton onClick={onClose}>Close</OutlineButton>{' '}
              {isProcessing ? (
                <Button varient="normal" disabled={isProcessing}>
                  <div style={{ paddingRight: '10px' }}></div>
                  <IntlMessages id="button.text.processing" />
                  <Loader size="small" isNotRequiredLoadingText={true} />
                </Button>
              ) : (
                <Button varient="normal" onClick={handleSendInvitation}>
                  Send
                </Button>
              )}
            </ModalButtonWrapper>
          </ModalWrapperInviteVisitor>
        ) : (
          <ModalWrapperInviteVisitor>
            <>
              <ModalLabel>{error}</ModalLabel>
            </>
            <ModalButtonWrapper>
              <Button varient="normal" onClick={onClose}>
                Close
              </Button>
            </ModalButtonWrapper>
          </ModalWrapperInviteVisitor>
        );
      case 'phone':
        return (
          <InviteVisitorModalViaPhone
            onClose={onClose}
            isProcessing={isProcessing}
            handleSendInvitationViaPhone={handleSendInvitationViaPhone}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={role !== 'ADMIN' ? 'Invite Visitor/Guest' : 'Invite Distributor'}
      >
        {role !== 'ADMIN' && role !== 'PARTNER' && (
          <TabWrapper>
            <Tab buttonArray={tabArray} onButtonClick={handleTabClick} activeTab={activeTab} />
          </TabWrapper>
        )}
        {renderTabContent()}
      </Modal>
    </>
  );
};

export default InviteVisitorModal;
